import { useEffect } from 'react'
import { useCreateVideoInstructionMutation } from 'services/video-instructions'
import { OrganizationType } from 'types/organization'
import { VideoFieldValues, VideoForm } from './video-form'
import { v4 as uuidv4 } from 'uuid'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
}

export const DialogCreateVideo = ({ onClose }: Props) => {
  const { t } = useTranslation()
  const [createVideoInstruction, { isSuccess, isError }] =
    useCreateVideoInstructionMutation()

  useEffect(() => {
    if (isSuccess) {
      onClose()
      toast.success(t('operation-success'))
    }
    if (isError) {
      toast.error(t('failedToCreate'))
    }
  }, [isSuccess, isError, t, onClose])

  return (
    <VideoForm
      onClose={onClose}
      defaultValues={{
        title: '',
        description: '',
        videoUrl: '',
        ordinal: 0,
        audienceOrganizationType: OrganizationType.CLIENT,
        instructionFileId: '',
      }}
      onSubmit={({
        title,
        description,
        videoUrl,
        ordinal,
        audienceOrganizationType,
        instructionFileId,
      }: VideoFieldValues) => {
        createVideoInstruction({
          id: uuidv4(),
          title,
          description,
          videoUrl,
          ordinal,
          audienceOrganizationType,
          instructionFileId,
        })
      }}
    />
  )
}
